import React from "react";
import "./Nero.css";

const Nero = () => {
  return (
    <div className="about-nero">
      <div className="about-nero-container">
        <div className="about-nero-mainText">Get paid the easy way</div>
        <div className="about-nero-showcase">
          <div className="about-nero-showcase-layer"></div>
          <div className="about-nero-text">
            <div className="topText neroText">
              We broaden the scope by allowing all types of businesses with
              different levels of customer sophistication receive payments
              easily. Customers who do not have cash, card, or even smartphones
              can easily pay with USSD and it’d be verified instantly with
              Qevolt.
            </div>

            <div className="botText neroText">
              We give businesses the platform to acquire new customers, satisfy
              existing ones, and increase sales beyond expectations. But it
              doesn’t end here. As our product evolves, we’d keep bringing in
              peculiar solutions to your business needs
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Nero;
